import { Outlet, useOutletContext } from 'react-router-dom';
import type { ApiClient } from '../api';
import { PageHeader } from '../rahmen/PageHeader';
import { LocalTabs } from '../rahmen/LocalTabs';

/**
 * Fremdmodelle — der Rahmen mit den Reitern.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * WARUM MEHRERE REITER UND NICHT EINE SEITE
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * Unter „Fremdmodelle" liegen zwei Dinge, die nichts miteinander zu tun haben
 * außer der Herkunft der Daten:
 *
 *   Fremdmodellaufnahme   Was sich in Architektur, Tragwerk, Küche und
 *                         Medientechnik geändert hat — eine Wochenliste mit
 *                         Folgen im eigenen Bestand.
 *
 *   Küchenplanung         Der fachliche Küchendatenbestand: 845 Geräte mit
 *                         1.066 Anschlusspunkten, gepflegt in der Datenbank
 *                         und nach Revit geschrieben.
 *
 * Beide auf einer Seite hieße: 1.418 Änderungen und 845 Komponenten
 * untereinander, und niemand findet mehr, was er sucht.
 *
 * Die Reiter sind Verweise und keine Zustandsschalter — ein Küchengerät soll
 * verlinkbar sein. Seit U6a führt sie `LocalTabs` aus dem Rahmen; die Klassen
 * (`unterreiter`, `aktiv`) sind dieselben wie vorher.
 */

interface Rahmen { api: ApiClient; projekt?: { id: string } }

export function Fremdmodelle() {
  const rahmen = useOutletContext<Rahmen>();

  return (
    <>
      <PageHeader
        titel="Fremdmodelle"
        beschreibung={'Was Architektur, Tragwerk, Küche und Medientechnik geliefert '
          + 'haben — und was daraus im eigenen Bestand folgt.'}
      >
        <LocalTabs
          ariaLabel="Fremdmodelle"
          eintraege={[
            { to: '.', beschriftung: 'Fremdmodellaufnahme', end: true },
            // end: Ohne das ist der Reiter auch unter kueche/aufnahme,
            // kueche/zuordnung und kueche/qualitaet aktiv - dort waren
            // dann ZWEI Reiter gleichzeitig hervorgehoben.
            { to: 'kueche', beschriftung: 'Küchenplanung', end: true },
            /* Die Aufnahme steht NEBEN der Küchenplanung und nicht darin: Sie
               beantwortet eine andere Frage. Die Planung zeigt den Bestand,
               die Aufnahme sagt, woher er kommt und ob er vollständig ist. */
            { to: 'kueche/aufnahme', beschriftung: 'Küchenaufnahme' },
            /* Die Zuordnung ist die Arbeit, das Gate die Abnahme. Zwei Reiter,
               weil man bei der einen stundenlang bleibt und bei der anderen
               nachsieht, ob es reicht. */
            { to: 'kueche/zuordnung', beschriftung: 'Zuordnung' },
            { to: 'kueche/qualitaet', beschriftung: 'Datenqualität' },
          ]}
        />
      </PageHeader>

      <Outlet context={rahmen} />
    </>
  );
}
